/* PDP-fotozoom, herbouwd (juli 2026).
   Gedrag: openen toont de foto passend op het scherm; pinch (touch) of
   dubbel-tik/dubbelklik zoomt in en slepen verschuift; één tik/klik of de
   X sluit en brengt je terug op de PDP. ESC sluit ook.
   Custom element blijft <product-image-zoom> met data-image (2048px). */
if (typeof ProductImageZoom !== 'function') {

  class ProductImageZoom extends HTMLElement {

    constructor() {
      super();
      this.addEventListener('click', () => ProductImageZoom.open(this.getAttribute('data-image')));
    }

    static ensureOverlay() {
      if (document.getElementById('pdp-zoom')) return document.getElementById('pdp-zoom');
      const overlay = document.createElement('div');
      overlay.id = 'pdp-zoom';
      overlay.innerHTML = '<img alt="" draggable="false"><button type="button" class="pdp-zoom__close" aria-label="Sluiten">&times;</button>';
      document.body.appendChild(overlay);

      const img = overlay.querySelector('img');
      const state = { scale: 1, x: 0, y: 0, pointers: new Map(), pinchStart: 0, scaleStart: 1, moved: false, lastTap: 0 };
      ProductImageZoom._state = state;

      const apply = () => {
        // pan begrenzen zodat de foto niet wegzweeft
        const maxX = Math.max(0, (img.offsetWidth * state.scale - overlay.clientWidth) / 2);
        const maxY = Math.max(0, (img.offsetHeight * state.scale - overlay.clientHeight) / 2);
        state.x = Math.min(maxX, Math.max(-maxX, state.x));
        state.y = Math.min(maxY, Math.max(-maxY, state.y));
        img.style.transform = 'translate(' + state.x + 'px,' + state.y + 'px) scale(' + state.scale + ')';
      };

      const close = () => {
        overlay.classList.remove('opened');
        document.documentElement.classList.remove('pdp-zoom-open');
        state.scale = 1; state.x = 0; state.y = 0;
        img.style.transform = '';
      };
      ProductImageZoom.close = close;

      overlay.querySelector('.pdp-zoom__close').addEventListener('click', (e) => { e.stopPropagation(); close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

      const dist = () => {
        const p = Array.from(state.pointers.values());
        return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      };

      overlay.addEventListener('pointerdown', (e) => {
        overlay.setPointerCapture(e.pointerId);
        state.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        state.moved = false;
        if (state.pointers.size === 2) { state.pinchStart = dist(); state.scaleStart = state.scale; }
      });

      overlay.addEventListener('pointermove', (e) => {
        if (!state.pointers.has(e.pointerId)) return;
        const prev = state.pointers.get(e.pointerId);
        const dx = e.clientX - prev.x, dy = e.clientY - prev.y;
        if (Math.abs(dx) + Math.abs(dy) > 3) state.moved = true;
        state.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        if (state.pointers.size === 2 && state.pinchStart > 0) {
          state.scale = Math.min(4, Math.max(1, state.scaleStart * (dist() / state.pinchStart)));
          apply();
        } else if (state.pointers.size === 1 && state.scale > 1) {
          state.x += dx; state.y += dy;
          apply();
        }
      });

      const release = (e) => {
        state.pointers.delete(e.pointerId);
        if (state.pointers.size < 2) state.pinchStart = 0;
        if (e.type !== 'pointerup') return;

        const now = Date.now();
        if (!state.moved && state.pointers.size === 0) {
          if (now - state.lastTap < 320) {
            // dubbel-tik: zoom wisselen
            state.scale = state.scale > 1 ? 1 : 2.5;
            if (state.scale === 1) { state.x = 0; state.y = 0; }
            apply();
            state.lastTap = 0;
          } else {
            state.lastTap = now;
            // enkele tik sluit — korte wachttijd zodat dubbel-tik voorrang houdt
            setTimeout(() => {
              if (state.lastTap === now && overlay.classList.contains('opened')) close();
            }, 330);
          }
        }
      };
      overlay.addEventListener('pointerup', release);
      overlay.addEventListener('pointercancel', release);

      return overlay;
    }

    static open(src) {
      const overlay = ProductImageZoom.ensureOverlay();
      const img = overlay.querySelector('img');
      const s = ProductImageZoom._state;
      s.scale = 1; s.x = 0; s.y = 0; img.style.transform = '';
      img.src = src || '';
      overlay.classList.add('opened');
      document.documentElement.classList.add('pdp-zoom-open');
    }
  }

  if (typeof customElements.get('product-image-zoom') == 'undefined') {
    customElements.define('product-image-zoom', ProductImageZoom);
  }
}
